import React, { useContext, useEffect, useRef } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import Header from "../Pages/Company/Header";
import useBreakPoints from "../hooks/useBreakPoints";
import Loader from "../Component/Loader";
import video from "../assets/images/Company/patern.mp4";
const AuthProtected = () => {
  const { isTablet } = useBreakPoints();
  const { token, loading, theme } = useContext(MyContext);
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log("Video autoplay failed:", error);
      });
    }
  }, [theme]); // Re-run when theme changes

  if (!token) {
    return <Navigate to="/" replace />;
  }

  console.log(token, "token");
  if (loading) {
    return <Loader />;
  }
  // Render child routes here using Outlet
  return (
    <>
      <div class={`${theme === "dark" ? "video-bg-body" : "body tmp-white-version "}`}>
        <div id="tmp-page-content-bento">
          <Header />
          <div className="">
            <Outlet />
          </div>
        </div>

   {theme === "dark" && (   <div className="hero-bg-video" data-black-overlay="5">
        <video 
          ref={videoRef}
          autoPlay 
          muted 
          loop 
          playsInline
          id="myVideo"
        >
          <source src={video} type="video/mp4" />
        </video>
      </div>)}
        
      </div>

    </>
  );
};

const AccessRoute = ({ component: Component }) => {
  // Render the passed component as a JSX element
  return <>{Component}</>;
};

export { AuthProtected, AccessRoute };
